import { css } from '@emotion/react';


export default $ => css`
  .filter-grid-container {
    margin-top: 8px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;

    > p {
      margin-bottom: 0;
    }

    .filter-grid-row {
      display: grid;
      padding-bottom: 8px;

      .dropdown {
        flex-grow: 1;

        .btn {
          width: 100%;
        }
      }
    }

    .filter-grid-filters {
      width: 100%;
    }

    .filter-input-group {
      & .dropdown .btn {
        width: 100%;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }

  /* Fine-tune the date header appearance */
  .header2-text-label {
    font-weight: bold;
    font-size: 20px;
  }

  /* Stronger grid lines for rows (resources) and columns (time slots) */
  .react-big-schedule .resource-view,
  .react-big-schedule .scheduler-view {
    border-color: #cfd8dc !important;
  }

  /* Horizontal lines across resource rows */
  .react-big-schedule table.resource-table tr,
  .react-big-schedule table.scheduler-bg-table tr,
  .react-big-schedule table.scheduler-table tr {
    border-bottom: 1px solid #cfd8dc !important;
  }

  /* Vertical lines between columns (time slots) */
  .react-big-schedule table.resource-table th,
  .react-big-schedule table.resource-table td,
  .react-big-schedule table.scheduler-bg-table td,
  .react-big-schedule table.scheduler-table th,
  .react-big-schedule table.scheduler-table td {
    border-right: 1px solid #cfd8dc !important;
    border-bottom: 1px solid #e0e0e0 !important; /* keep row separators visible under events */
  }

  /* slightly darker header separator */
  .react-big-schedule table.scheduler-table th {
    border-bottom-color: #b0bec5 !important;
  }

  /* Reveal background grid lines (content layer must be transparent) 
    In UWE there is a global table rule that sets the background to white.
    see (src/styles/_uwestyles.css.js). This css force the background lines to be visible.
  */
  .react-big-schedule .scheduler-content,
  .react-big-schedule table.scheduler-content-table,
  .react-big-schedule table.scheduler-content-table tr,
  .react-big-schedule table.scheduler-content-table td,
  .react-big-schedule table.scheduler-content-table th {
    background: transparent !important;
  }

  /* Keep the left resource panel above the background grid that spans behind */
  .react-big-schedule .resource-view {
    position: relative;
    z-index: 3;
  }

  .react-big-schedule .resource-view td,
  .react-big-schedule .resource-view .overflow-text {
    position: relative;
    z-index: 3;
  }

  /* Avatar for resource rows */
  .react-big-schedule .rbs-avatar {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #607d8b;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 12px;
    margin-left: 10px;
    padding: 18px;
  }

  /* Make resource cell content consume full cell width and truncate text safely */
  .react-big-schedule .overflow-text {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
  }

  .react-big-schedule .resource-view .overflow-text {
    display: grid; /* avatar + text en columnas */
    grid-template-columns: auto 1fr;
    align-items: center;
    column-gap: 8px;
    white-space: normal; /* permitir wrap en la columna de recursos */
    overflow: hidden;
  }

  .react-big-schedule .resource-view .rbs-name {
    /* Fallback: wrap normally up to ~3 líneas; si excede, clipea con elipsis */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* ajusta si cambias nonAgendaSlotMinHeight */
    line-height: 1.2;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
  }

  .react-big-schedule .overflow-text .rbs-avatar {
    flex: 0 0 auto; /* keep avatar size fixed */
  }

  .react-big-schedule .overflow-text .rbs-name {
    flex: 1 1 auto;
    min-width: 0;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
  }

  /* Ensure left alignment inside resource column */
  .react-big-schedule table.resource-table td .slot-text,
  .react-big-schedule table.resource-table td {
    text-align: left !important;
  }

  /* Permitir que las filas crezcan según el contenido en ambas tablas (bg y content) */
  .react-big-schedule table.resource-table tbody tr td,
  .react-big-schedule table.scheduler-bg-table tbody tr td,
  .react-big-schedule table.scheduler-table tbody tr td {
    height: unset;
    vertical-align: middle;
  }

  .rbs-loading-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.5);
    z-index: 2; /* above the grid */
    pointer-events: none; /* set to 'all' if you want to block interaction while loading */
  }

  .rbs-spinner {
    width: 44px;
    height: 44px;
    border: 4px solid rgba(0, 0, 0, 0.15);
    border-top-color: #1890ff;
    border-radius: 50%;
    animation: rbs-spin 0.8s linear infinite;
  }

  @keyframes rbs-spin {
    to { transform: rotate(360deg); }
  }
`;
